import MegUI from "meg-ui";
import "meg-ui/lib/theme/index.css";

let Vue;

export default {
  install(_Vue) {
    if (Vue) return;

    Vue = _Vue;

    Vue.use(MegUI);
  },
};
